// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support', {
        url: '/support-975630f2-68b1-42ec-8302-2710af93a5e5',
        parent: 'main',
        abstract: true,
        templateUrl: "main/support/support.tpl.html",
        controller: "SupportController as vm"
    });
}

// @ngInject
function SupportController() {
    var vm = this;
}

angular
    .module('main.support', ['support.supportcases'])
    .config(stateConfig)
    .controller('SupportController', SupportController);
